import {compose} from 'ramda';

export const removeQueryParams = url => /\?/.test(url) ? url.substring(0, url.indexOf('?')) : url;

export const urlStringToArray = url => url.split(/\/|-/);

const cleanUrl = compose(urlStringToArray, decodeURI, removeQueryParams);

export const urlToArray = url => {
    const urlArray = cleanUrl(url);
    const inInd = urlArray.findIndex(e => e === 'in');

    return {
        urlArray,
        inInd
    }
}

export const formatBreadCrumbLink = ({ url, urlResult }) => `${process.env.CVNA_APP_SEO_BASE_URL}/${url}${urlResult ? urlResult.search : ''}`;
